<template lang='slm'>
  div
    .section.answer
      .container.pt-4.pb-4
        h2 Ответ на вопрос
        center v-if='$apollo.loading'
          h3 Загрузка...
        template v-else=''
          .mb-3.p-3.border v-if='question.previousQuestions.length'
            h3 Диалог:
            .mb-2 v-for='q in question.previousQuestions'
              strong.d-block {{ q.question }}
              span {{ q.answer }}
          .mb-3
            h3 Ваш вопрос:
            pre {{ question.question }}
          .mb-3 v-if='question.answer'
            h3 Ответ на ваш вопрос:
            pre {{ question.answer }}
            router-link.btn.btn-secondary :to='"/question?prev=" + link' Продолжить диалог
          .mb-3 v-else=''
            span Похоже, на ваш вопрос ещё не ответили. Зайдите на страницу позже чтобы увидеть ответ.
</template>

<style lang='stylus' scoped>
#main
  background-color white
.answer
  text-align left
  pre
    white-space normal
</style>

<script>
import gql from 'graphql-tag';

export default {
  name: 'QuestionAnswerPage',
  data() {
    return {
      question: {},
    };
  },
  props: {
    link: {
      type: String,
      required: true,
    },
  },
  apollo: {
    question: {
      query: gql`query ($link: String!) { question(link: $link) { question answer previousQuestions { question answer } } }`,
      variables() {
        return {
          link: this.link,
        };
      },
      skip() {
        return !this.link;
      },
      error() {
        this.$router.push({ path: '/' });
      },
    },
  },
};
</script>
